<div class="header bg-white text-dark text-center px-3 fixed-top">
    <div class="container">
        <div class="d-flex">
            <div>
                <div *ngIf="(authService.user$ | async) != null">
                    <p class="text-start h7 lh-1" (dblclick)="navigateToImpersonation()">
                        {{ greetingTextKey | transloco }}
                    </p>
                    <p class="text-start h2 lh-1" (dblclick)="navigateToImpersonation()">
                        {{ (authService.user$ | async)?.givenName}}
                    </p>
                </div>
            </div>
            <div class="flex-grow-1"></div>
            <div>
                <img class="logo" src="/assets/images/logos/asvz/asvz_logo_blue.svg" />
            </div>
        </div>
    </div>
</div>